import React, { useEffect, forwardRef, useRef } from 'react';
import styles from './css/checkbox.module.css';

const Checkbox = forwardRef(({ indeterminate, ...rest }, ref) => {
  const defaultRef = useRef();
  const resolvedRef = ref || defaultRef;
  useEffect(() => {
    resolvedRef.current.indeterminate = indeterminate;
  }, [resolvedRef, indeterminate]);

  return (
    <label className={styles.checkbox}>
      <input type="checkbox" ref={resolvedRef} {...rest} />
      <span className={styles.checkmark}></span>
    </label>
  );
});

export default Checkbox;
